<template>
  <div @contextmenu.prevent.stop="onContextmenu">
    <sj-question-file :disabled="disabled">
      <sj-question-file-progress v-for="({percentage}, index) in progress"
                                 :key="index"
                                 :percentage="percentage"></sj-question-file-progress>
      <sj-question-file-item v-for="(file, index) in files"
                             :key="index"
                             :poster="file.src"
                             :disabled="disabled"
                             @click.stop.native="view(index)"
                             @contextmenu.prevent.stop.native="(event)=>{onContextmenu(event, index)}"
                             @remove="remove(index)"></sj-question-file-item>
      <el-tooltip
        effect="dark"
        content="添加图片"
        placement="top">
        <sj-question-file-add :disabled="disabled || files.length > 0"
                              @click="$refs.selectFile.click()"></sj-question-file-add>
      </el-tooltip>
    </sj-question-file>
    <input ref="selectFile"
           v-if="!disabled"
           v-show="false"
           type="file"
           accept=".png,.jpg,.jpeg,.gif"
           @change="upload">
  </div>
</template>

<script>
import ContextMenu from '@/views/question-review/components/ContextMenu'
import SjQuestionFile from '@/views/question-editor/packages/sj-question-file'
import SjQuestionFileItem from '@/views/question-editor/packages/sj-question-file-item'
import SjQuestionFileAdd from '@/views/question-editor/packages/sj-question-file-add'
import SjQuestionFileProgress from '@/views/question-editor/packages/sj-question-file-progress'

export default {
  components: {SjQuestionFileProgress, SjQuestionFileAdd, SjQuestionFileItem, SjQuestionFile},
  mixins: [],
  inject: ['playImage'],
  props: {
    value: Array,
    disabled: Boolean,
  },
  data () {
    return {
      uniqueId: _.uniqueId(),
      progress: [
        // percentage: 0,
      ],
      uploadApi: 'uploadStepTemplateFile'
    }
  },
  computed: {
    files: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {
    this.addEventListener()
  },
  mounted () {
    ContextMenu({
      uploadApi: this.uploadApi
    }, true).appendElement('.step-template-content-container')
  },
  destroyed () {
    this.removeEventListener()
  },
  methods: {
    view (index) {
      this.playImage(this.value, index)
    },
    upload () {
      let file = this.$refs.selectFile.files[0]
      if (this.validate(file)) {
        // 显示进度条
        let progress = {
          percentage: 0,
          file: file,
        }
        this.progress.push(progress)
        // 生成请求数据
        let form = new FormData()
        form.append('file', file)
        request.alert('uploadStepTemplateFile', form, {
          onUploadProgress: progressEvent => {
            progress.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0)
          }
        }).then(({data}) => {
          this.files.push({type: 'photo', src: data})
        }).finally(() => {
          this.progress.splice(this.progress.indexOf(progress), 1)
        })
      }
      this.$refs.selectFile.value = null
    },
    validate (file) {
      const size = 5
      const isLtSize = file.size / 1024 / 1024 < size
      if (!isLtSize) {
        this.$message.error(`上传图片大小不能超过 ${size}MB!`)
      }
      return isLtSize
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    onContextmenu ({clientX, clientY}, index) {
      if (Number.isInteger(index) && index >= 0) {
        let file = this.files[index]
        ContextMenu().empty()
        ContextMenu().checked(file)
      } else {
        ContextMenu().empty()
      }
      // 限制拷贝数量
      ContextMenu({pasteMax: ~~!this.files.length})
      ContextMenu().setScope(this.uniqueId)
      ContextMenu().setType(this.type)
      ContextMenu().setFiles(this.files)
      ContextMenu().show(clientX, clientY)
    },
    addEventListener () {
      document.addEventListener('click', this.clickDoc)
    },
    removeEventListener () {
      document.removeEventListener('click', this.clickDoc)
    },
    clickDoc () {
      ContextMenu().hide()
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/SjQuestionOneImage.vue